import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class PreviewIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16"><path d="M17.6 8.2c-2.1-2.6-5-3.9-8.6-3.9-3.6 0-6.5 1.3-8.6 3.9l-.5.6.6.5c3 2.3 5.9 3.5 8.4 3.5s5.2-1.1 8.2-3.3l.9-.7-.4-.6zm-10.1 2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zM5 6.5c-.5.5-.8 1.2-.8 2 0 .6.2 1.1.4 1.6-.8-.4-1.6-.9-2.5-1.6.8-.9 1.8-1.5 2.9-2zm4.2 4.7c.9-.6 1.5-1.6 1.5-2.7 0-1.2-.6-2.2-1.5-2.7 2.8 0 5 .9 6.7 2.8-2.4 1.7-4.7 2.6-6.7 2.6z" fill="#8d979a"/></svg>
        )
    }
}

export default withCssClassName(PreviewIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/preview-icon.js